import { LinkExpirationSetting, LinkExpirationSettingPayload } from 'modules/domains/links';
import { ApiMethod } from 'services/api';
import {
  RestQueryHookOptions,
  UseRestMutationOptions,
  useRestMutation,
  useRestQuery,
} from 'utils/hooks/api';

export const LINK_EXPIRATION_URL = '/settings/linkExpiration';
export const DELETE_LINK_URL = '/settings/deleteLinkExpiration';
export const LINK_EXPIRATION_DATE_OPTIONS_URL = '/settings/linkExpirationManagementDateOptions';

type GetLinkResponse = { linkExpirationSettings: LinkExpirationSetting[] };
type DeleteParams = { projectIds: number[] };

/** Fetches all links for the organization */
export const useGetLinkExpiration = (options?: RestQueryHookOptions) =>
  useRestQuery<GetLinkResponse>(LINK_EXPIRATION_URL, {}, options);

/** Create or modify existing links */
export const useCreateOrUpdateLink = (options?: UseRestMutationOptions) =>
  useRestMutation<unknown, LinkExpirationSettingPayload>(
    LINK_EXPIRATION_URL,
    ApiMethod.post,
    options,
  );

/** Delete links */
export const useDeleteLink = (options?: UseRestMutationOptions) =>
  useRestMutation<unknown, DeleteParams>(DELETE_LINK_URL, ApiMethod.delete, options);

/**
 * Effective date options
 * Dynamic list of valid date values for link expiration
 */
export const useGetEffectiveDateOptions = (options?: RestQueryHookOptions) =>
  useRestQuery<string[]>(LINK_EXPIRATION_DATE_OPTIONS_URL, {}, options);
